import ReactToastify from '../../customHook/useReactToastify';
import ExcelJS from 'exceljs';

const formatHeader = (key) => {
  if (!key) return '';
  let result = key.replace(/([a-z])([A-Z])/g, '$1 $2');
  result = result.replace(/_/g, ' ');
  result = result.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1)
  );
  return result;
};

function AIReport({
  rows,
  filename = 'report.xlsx',
  isTable = false,
  isExcel = false,
}) {
  const downloadExcel = async () => {
    if (!rows || !rows.length) {
      ReactToastify({
        message: 'No data available to generate the report.',
        success: false,
      });
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');

    const PageLayouts = Object.keys(rows[0]);
    const formattedHeaders = PageLayouts.map(formatHeader);

    const PageLayoutRow = worksheet.addRow(formattedHeaders);

    PageLayoutRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '6E3EF5' },
      };
      cell.font = { color: { argb: 'FFFFFF' }, bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    rows.forEach((row) => {
      const rowData = PageLayouts.map((fieldName) => {
        let value = row[fieldName] ?? '';
        if (typeof value === 'object') value = JSON.stringify(value);
        if (value instanceof Date) value = value.toISOString().split('T')[0];
        return value;
      });
      worksheet.addRow(rowData);
    });

    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellLength = cell.value ? cell.value.toString().length : 0;
        if (cellLength > maxLength) maxLength = cellLength;
      });
      column.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const PageLayouts = rows && rows.length ? Object.keys(rows[0]) : [];

  return (
    <div className="space-y-4 w-full">
      {isExcel && (
        <div className="flex justify-end">
          <button
            onClick={downloadExcel}
            disabled={!rows || rows.length === 0}
            className="text-sm px-4 py-2 rounded-lg bg-purple-100 text-purple-700 font-medium hover:bg-purple-600 hover:text-white transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Download Report
          </button>
        </div>
      )}
      {isTable && rows && rows.length > 0 && (
        <div className="w-full overflow-x-auto border rounded-lg">
          <table className="text-sm text-left text-gray-700">
            <thead className="bg-gray-100">
              <tr>
                {PageLayouts.map((PageLayout) => (
                  <th
                    key={PageLayout}
                    className="px-4 py-2 whitespace-nowrap border-b font-medium text-xs"
                  >
                    {formatHeader(PageLayout)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx} className="border-t hover:bg-gray-50">
                  {PageLayouts.map((PageLayout) => (
                    <td
                      key={PageLayout}
                      className="px-4 py-2 whitespace-nowrap"
                    >
                      {typeof row[PageLayout] === 'object'
                        ? JSON.stringify(row[PageLayout])
                        : row[PageLayout] ?? ''}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AIReport;
